import { LoggingService } from '@adaptiva/core/logging';
import { OidcService } from '@adaptiva/data-service';
import { Directive, HostBinding, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Directive()
export abstract class OidcLandingPage {

	public readonly errorMessage: BehaviorSubject<string> = new BehaviorSubject('');

	@HostBinding('style')
	public readonly hostStyles: Record<string, string> = {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		width: '100%'
	};
	
	protected readonly oidc: OidcService = inject(OidcService);
	
	protected readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
	
	protected readonly router: Router = inject(Router);
	
	protected readonly logger: LoggingService = inject(LoggingService);

}
